import { render, staticRenderFns } from "./ProfessionSelector.vue?vue&type=template&id=43192040"
import script from "./ProfessionSelector.vue?vue&type=script&lang=js"
export * from "./ProfessionSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports